import { GRID, CELL, PATHS, HOME_CELLS, SAFE_CELLS } from "./constants";

const COLORS = {
  RED: "#ef4444",
  GREEN: "#22c55e",
  YELLOW: "#eab308",
  BLUE: "#3b82f6",
};

export default function LudoBoardSVG({ tokens }) {
  return (
    <svg
      viewBox={`0 0 ${GRID * CELL} ${GRID * CELL}`}
      className="w-full max-w-md mx-auto bg-white rounded-2xl shadow-xl"
    >
      {/* Background */}
      <rect width="100%" height="100%" fill="#f8fafc" />

      {/* Home Zones (2x2 corners) */}
      {Object.entries(HOME_CELLS).map(([color, cells]) =>
        cells.map(([r, c], i) => (
          <rect
            key={color + i}
            x={c * CELL}
            y={r * CELL}
            width={CELL}
            height={CELL}
            fill={COLORS[color]}
            opacity="0.3"
          />
        ))
      )}

      {/* Central Cross Path */}
      {[...Array(GRID)].map((_, r) =>
        [...Array(GRID)].map((_, c) => {
          // Only draw empty squares in the path area
          const inMiddle = (r >= 6 && r <= 8) || (c >= 6 && c <= 8);
          return (
            <rect
              key={`${r}-${c}`}
              x={c * CELL}
              y={r * CELL}
              width={CELL}
              height={CELL}
              fill={inMiddle ? "#f8fafc" : "none"}
              stroke="#333"
              strokeWidth={0.5}
            />
          );
        })
      )}

      {/* Safe Cells */}
      {SAFE_CELLS.map(([r, c], i) => (
        <circle
          key={i}
          cx={c * CELL + CELL / 2}
          cy={r * CELL + CELL / 2}
          r={CELL / 6}
          fill="#94a3b8"
        />
      ))}

      {/* Tokens */}
      {Object.entries(tokens).map(([color, list]) =>
        list.map((t, i) => {
          if (t.step < 0 || t.finished) return null;
          const [r, c] = PATHS[color][t.step];
          return (
            <circle
              key={color + i}
              cx={c * CELL + CELL / 2}
              cy={r * CELL + CELL / 2}
              r={CELL / 3}
              fill={COLORS[color]}
              stroke="#000"
              strokeWidth={1}
            />
          );
        })
      )}
    </svg>
  );
}
